import React, { useMemo } from "react";
import { Filter, RotateCcw, X } from "lucide-react";
import {
  buildAppliedFilterChips,
  hasActiveCampaignFilters,
} from "../../utils/campaignFilterLabels";

export default function CampaignAppliedFiltersBar({
  filters,
  phoneAccounts = [],
  templates = [],
  onRemoveFilter,
  onClearAll,
  onEditFilters,
  loading = false,
}) {
  const chips = useMemo(
    () => buildAppliedFilterChips(filters, { phoneAccounts, templates }),
    [filters, phoneAccounts, templates]
  );

  if (!hasActiveCampaignFilters(filters)) {
    return null;
  }

  return (
    <div className="camp-applied">
      <div className="camp-applied-ico">
        <Filter size={14} />
      </div>
      <div className="camp-applied-copy">
        <b>Applied filters</b>
        <span>{chips.length} active{loading ? " · updating…" : ""}</span>
      </div>
      <div className="camp-applied-chips">
        {chips.map((chip) => (
          <span key={chip.key} className="ping-chip n">
            {chip.label}
            <button
              type="button"
              onClick={() => onRemoveFilter(chip.field)}
              disabled={loading}
              aria-label={`Remove ${chip.label}`}
            >
              <X size={11} />
            </button>
          </span>
        ))}
      </div>
      <div className="camp-applied-btns">
        {onEditFilters && (
          <button type="button" onClick={onEditFilters} className="ping-btn ping-btn-ghost ping-btn-sm">
            Edit
          </button>
        )}
        <button type="button" onClick={onClearAll} disabled={loading} className="ping-btn ping-btn-ghost ping-btn-sm">
          <RotateCcw size={12} />
          Clear
        </button>
      </div>
    </div>
  );
}
